module.exports = __webpack_public_path__ + "img/tairitsu_ost_elegy.9033d25c.png";